import React, { Component } from "react";
import Uploader from "../uploader";

export default class MobileFloors extends Component {
  render() {
    return (
      <div className="relative">
        <button
          name="scroll-right"
          className="m-0 button-shadow-right scroll"
        ></button>

        <ul>
          {this.props.floors.map((floor) => (
            <li
              onClick={() => this.props.selectHandler("floor", floor)}
              style={{
                background: floor.color_code ? floor.color_code : "",
              }}
              className={
                this.props.selectedFloor &&
                this.props.selectedFloor.id === floor.id
                  ? "active"
                  : ""
              }
              key={"floorImage" + floor.id}
            >
              {" "}
              {floor.image && <img src={floor.image} alt="cover" />}{" "}
            </li>
          ))}
        </ul>
        <button
          name="scroll-left"
          className="m-0 button-shadow-left scroll"
        ></button>
        <Uploader
          selected={
            this.props.selectedFloor && this.props.selectedFloor.custom
              ? this.props.selectedFloor
              : null
          }
          selectHandler={this.props.customSelectHandler}
          removeHandler={this.props.removeHandler}
		  decorationType={"floor"}
		  texts={this.props.texts}
        />
      </div>
    );
  }
}
